import { createSlice } from "@reduxjs/toolkit";
import { getPurchaseOrder } from "../../reduxApi/admin/PurchaseOrderReduxApi";
import { getSupplierApi, getSupplierCountApi } from "../../reduxApi/admin/SupplierReducApi";

const SupplierSlice = createSlice({
  name: "Supplier",
  initialState: {
    status: "idle",
    getSupplier: [],
    getSupplierCount: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSupplierApi.fulfilled, (state, action) => {
      state.status = "fulfilled";
      state.getSupplier = action.payload.supplier;
      console.log("state.getsupplier", state.getSupplier);
    });
    builder.addCase(getSupplierCountApi.fulfilled, (state, action) => {
      state.status = "fulfilled";
      state.getSupplierCount = action.payload.data.count;
      console.log("state.getsupplier", state.getSupplier);
    });
  },
});

export default SupplierSlice.reducer;
